import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({name: "sanitizeResourceUrl"})
export class SanitizeResourceUrlPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer){}
    transform(url: string) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}